import { useCallback, useEffect, useState } from 'react'
import BackOfficeAPIClient from "../../../clients/BackofficeAPIClient"
import { Site } from "../../../types/Site"
import { CATALOG_KEYS, CatalogKey } from "../../../types/Catalog"
import { TypeChamp } from "../../../enums/TypeChamp"

interface UseAvailableCatalogsReturn
{
    availableCatalogs: CatalogKey[]
    availableTypeChamps: TypeChamp[]
    loading: boolean
}

/**
 * Correspondance catalogue -> TypeChamp. MotorcycleManualEntry et RecreationalManualEntry n'y
 * figurent pas volontairement : leur disponibilité dépend des activités du groupe
 * (useAvailableActivities), pas des catalogues.
 */
const CATALOG_KEY_TO_TYPE_CHAMP: Record<CatalogKey, TypeChamp> = {
    AutovistaActif: TypeChamp.Autovista,
    KifalActif: TypeChamp.Kifal,
    RefVdlActif: TypeChamp.RecreationalReference,
    RefMotoActif: TypeChamp.MotorcycleReference,
    AutobizActif: TypeChamp.Autobiz,
}

/**
 * Catalogues actifs sur au moins un site du groupe (RefMoto, RefVdl, Autovista, Kifal, Autobiz) :
 * mêmes règles que dans Interfaces/Catalogues (voir refMotoActif/refLoisirActif), généralisées
 * aux 5 catalogues.
 */
const useAvailableCatalogs = (): UseAvailableCatalogsReturn => {
    const apiClient = new BackOfficeAPIClient()
    const [ availableCatalogs, setAvailableCatalogs ] = useState<CatalogKey[]>([])
    const [ loading, setLoading ] = useState<boolean>(true)

    const fetchAvailableCatalogs = useCallback(async () => {
        setLoading(true)
        try {
            const sites = await apiClient.get<Site[]>('/sites')
            setAvailableCatalogs(CATALOG_KEYS.filter(key => sites.some(site => site[key])))
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchAvailableCatalogs()
    }, [ fetchAvailableCatalogs ])

    return {
        availableCatalogs,
        availableTypeChamps: availableCatalogs.map(key => CATALOG_KEY_TO_TYPE_CHAMP[key]),
        loading,
    }
}

export default useAvailableCatalogs
